import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingCount = 0;

  // Estado reactivo con Signal
  private readonly _isLoading = signal<boolean>(false);

  // Exponemos como Readonly Signal para que nadie lo modifique desde fuera
  readonly isLoading = this._isLoading.asReadonly();

  // Mantenemos compatibilidad con Observable por si algún componente viejo lo usa (opcional)
  // pero lo ideal es migrar a usar isLoading()
  // loading$ = toObservable(this._isLoading); 

  private showTimestamp = 0;

  show(): void {
    if (this.loadingCount === 0) {
      this.showTimestamp = Date.now();
      this._isLoading.set(true);
    }
    this.loadingCount++;
  }

  hide(): void {
    this.loadingCount = Math.max(this.loadingCount - 1, 0);
    if (this.loadingCount === 0) {
      const elapsed = Date.now() - this.showTimestamp;
      const delay = Math.max(400 - elapsed, 0); // espera mínimo 400ms

      setTimeout(() => {
        if (this.loadingCount === 0) {
          this._isLoading.set(false);
        }
      }, delay);
    }
  }
}
